import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import WorkerDashboard from '../WorkerDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import WorkerPageImpl from './WorkerPageImpl';

export default function WorkerPage() {
    const dispatch = useDispatch();
    const { workerList} = useSelector((state)=>state.manufslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':true}));
    },[]);

    return (
        < WorkerPageImpl />
    )

}